import "./styles.scss";

// A row action with an icon in front of its label. The icon should draw with
// `currentColor` so it follows the button's text colour, disabled state included.
const ActionButton = ({ icon, children, onClick, disabled = false, title, style }) => (
  <button
    type="button"
    className="action-button"
    title={title}
    onClick={onClick}
    disabled={disabled}
    style={style}>
    {icon}
    <span>{children}</span>
  </button>
);

export default ActionButton;
